















import Vue from "vue";
import BasicCardTemplate from "./BasicCardTemplate.vue";
import { getModule } from "vuex-module-decorators";
import TodayModule from "@/views/Today/TodayModule";

interface State {
  module: TodayModule;
}

export default Vue.extend({
  name: "CreateOrganizationCard",
  methods: {
    redirectToSubscribe() {
      this.$router.push(`/subscriptions/signup`);
    }
  }
});
